import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { environment } from "src/environments/environment";
import {
  AplicarSaldoResponse,
  MiSaldoResponse,
  MisPagosResponse,
} from "../models/saldo.model";

/**
 * Saldo a favor del paciente.
 *
 * La ACREDITACIÓN vive en CitaService.cancelarCita(): el endpoint /cancelarCita
 * cancela y acredita en una sola operación. Aquí no está porque cancelar es una
 * operación de citas, no de saldos. Este servicio solo consulta y aplica.
 *
 * /saldo/ajuste no se expone a propósito: es administrativo y requiere X-API-Key,
 * que no puede vivir en el bundle del paciente.
 */
@Injectable({
  providedIn: "root",
})
export class SaldosService {
  constructor(private httpClient: HttpClient) {}

  /**
   * Aplica el saldo disponible a una cita. Llamar SIEMPRE antes de abrir Wompi.
   * Es idempotente por cita: llamarlo dos veces no gasta el saldo dos veces.
   */
  aplicarSaldo(
    idPaciente: string,
    idCita: string,
    valorCita: number
  ): Promise<AplicarSaldoResponse> {
    return firstValueFrom(
      this.httpClient.post<AplicarSaldoResponse>(
        environment.apiPsicologa + "/saldo/aplicar",
        { idPaciente, idCita, valorCita }
      )
    );
  }

  /** Saldo disponible y sus movimientos. En movimientos el valor es siempre positivo. */
  getMiSaldo(idPaciente: string): Promise<MiSaldoResponse> {
    return firstValueFrom(
      this.httpClient.post<MiSaldoResponse>(
        environment.apiPsicologa + "/getMiSaldo",
        { idPaciente }
      )
    );
  }

  /**
   * Historial unificado de pagos de citas + movimientos de saldo,
   * ya ordenado por fecha descendente. Base de la pantalla /mis-pagos.
   */
  getMisPagos(idPaciente: string): Promise<MisPagosResponse> {
    return firstValueFrom(
      this.httpClient.post<MisPagosResponse>(
        environment.apiPsicologa + "/getMisPagos",
        { idPaciente }
      )
    );
  }
}
